export default __webpack_public_path__ + "static/media/jest.19f1f902.svg";